import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import atorch from './atorch';
import report from './report';
export const createRootReducer = (history) => combineReducers({
    router: connectRouter(history),
    atorch,
    report,
});
